export default __webpack_public_path__ + "static/media/oscer-pres-headache.ac702c2b.svg";